import {
  TableV2PassRateCell,
  TableV2ToneChip,
} from '@/features/shared/components/tableSystem/TableV2Primitives';
import { getStatusChipColor } from '@/ui/primitives';
import type { ExecutionRunCounts } from './ExecutionRunsTableV2RowHelpers';
import type { SuiteRunStatus, TestRunStatus } from '@flowqa/shared';
import type { ReactElement } from 'react';

export const StatusChip = ({
  label,
  status,
}: {
  label: string;
  status: SuiteRunStatus | TestRunStatus | null | undefined;
}): ReactElement => <TableV2ToneChip label={label} tone={getStatusChipColor(status)} />;

export const PassRateCell = ({ counts }: { counts: ExecutionRunCounts }): ReactElement => (
  <TableV2PassRateCell counts={counts} />
);
